var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-con"},[_c('div',{staticClass:"title-top"},[_c('img',{attrs:{"src":_vm.src,"alt":""}}),_c('span',[_vm._v(_vm._s(_vm.name))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }